export enum EMessagesTypes {
  GUEST = 'guest',
  COMPANY = 'company'
}
